"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C4.3431 2 3 3.3432 3 5c0 1.6569 1.3431 3 3 3a2.9861 2.9861 0 0 0 1.5331-.4208L9.1863 8.957A2.9938 2.9938 0 0 0 9 10c0 1.6569 1.3431 3 3 3 1.7808 0 3.1941-1.6147 2.9772-3.3713l.9397-.4698A2.99 2.99 0 0 0 18 10c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3c-1.7802 0-3.1934 1.6137-2.9774 3.37l-.9405.4702A2.9899 2.9899 0 0 0 12 7a2.986 2.986 0 0 0-1.533.4207L8.8137 6.043A2.9937 2.9937 0 0 0 9 5c0-1.6568-1.3431-3-3-3zM5 5c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1zm12 2c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1zm-5 2c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1z"
  }), _react.default.createElement("path", {
    d: "M4 10v10h2V10H4zm14 10v-8h2v8h-2zm-7 0v-5h2v5h-2z"
  })];
};

exports.default = _default;